import React from 'react';
import LazyLoad from '../components/shared/lazyLoad';
import { Switch, Route } from 'react-router';
import routes from '../routes';

const Eligibility = LazyLoad(() => import("./eligibility"));
const SubscriberInfo = LazyLoad(() => import("./subscriberInfo"));
const DependentInfo = LazyLoad(() => import("./dependentInfo"));
const ReviewSelectionContainer= LazyLoad(() => import("./reviewSelection"));

const RouteContainer = () => {
  return (
    <Switch>
      <Route exact path={`${routes.eligibility.base}/:page`} component={Eligibility} />
      <Route exact path={`${routes.subscriberInfo.base}/:page`} component={SubscriberInfo} />
      <Route exact path={`${routes.dependentInfo.base}/:page`} component={DependentInfo} />
      <Route exact path={routes.reviewSelection.base} component={ReviewSelectionContainer} />
      <Route exact path={`${routes.reviewSelection.base}/:page`} component={ReviewSelectionContainer} />
    </Switch>
  )
}

export default RouteContainer;